import React from 'react'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'

// 参考資料
// https://github.com/gsi-cyberjapan/gsimaps-vector-experiment

export const GsiVectorLayer = () => {
  const state = useGlobalState()
  const sourceId = IDs.gsiVector.source
  const layerId = IDs.gsiVector.layer

  React.useEffect(() => {
    if (!state.mapbox) return
    load()
    state.mapbox.on('style.load', load)
    return () => {
      state.mapbox?.off('style.load', load)
    }
  }, [state.mapbox])

  const load = () => {
    state.map.addSource(sourceId, {
      'type': 'vector',
      'tiles': [
        'https://cyberjapandata.gsi.go.jp/xyz/experimental_bvmap/{z}/{x}/{y}.pbf'
      ]
    })

    // state.map.addLayer({
    //   'id': layerId + 'river-line',
    //   'type': 'line',
    //   'source': sourceId,
    //   'source-layer': 'river',
    //   'layout': {
    //     'line-cap': 'round',
    //     'line-join': 'round'
    //   },
    //   'paint': {
    //     'line-opacity': 0.6,
    //     'line-color': 'purple',
    //     'line-width': 2
    //   }
    // })

    // state.map.addLayer({
    //   'id': layerId + '-rivername',
    //   'type': 'symbol',
    //   'source': sourceId,
    //   'source-layer': 'label',
    //   'filter': ['all', ['==', 'ftCode', 100], ['==', 'annoCtg', 621]],
    //   'layout': {
    //     'text-field': ['get', 'knj'],
    //     'text-line-height': 2.0
    //   },
    //   'paint': {
    //     'text-color': 'red'
    //   }
    // })

    state.map.addLayer({
      'id': layerId + '-mapillary',
      'type': 'line',
      'source': sourceId,
      'source-layer': 'boundary',
      'layout': {
        'line-cap': 'round',
        'line-join': 'round'
      },
      'paint': {
        'line-opacity': 0.6,
        'line-color': 'red',
        'line-width': 2
      },
      minzoom: 4,
      maxzoom: 8
    })

    // state.map.addSource('transit_line_line',
    //   {
    //     "url": "mapbox://mapbox.transit-v2",
    //     "type": "vector"
    //     }
    // )

    // state.map.addLayer({
    //   "id": "transit_line_line",
    //   "source": "transit_line_line",
    //   "source-layer": "transit_line",
    //   "type": "line",
    //   "filter": [
    //   "==",
    //   "$type",
    //   "LineString"
    //   ],
    //   "paint": {
    //   "line-width": 2,
    //   "line-color": "rgba(66,100,251, 0.3)"
    //   }
    //   })

    // state.map.addSource('mapbox-streets-999', {
    //   'type': 'vector',
    //   url: 'mapbox://mapbox.mapbox-streets-v8'
    // })
    // state.map.addLayer(
    //   {
    //     'id': 'mapbox-streets',
    //     'type': 'line',
    //     'source': 'mapbox-streets',
    //     'source-layer': 'contour',
    //     'layout': {
    //       'line-join': 'round',
    //       'line-cap': 'round'
    //     },
    //     'paint': {
    //       'line-color': '#ff69b4',
    //       'line-width': 1
    //     }
    //   }
    // )

    // state.map.addLayer(
    //   {
    //   'id': 'road-detail999',
    //   'source': 'mapbox-streets-999',
    //   "source-layer": "road-detail",
    //   'type': 'raster',
    //   // insert below waterway-river-canal-shadow;
    //   // where hillshading sits in the Mapbox Outdoors style
    //   }
    //   );

    // state.map.addLayer({
    //   'id': layerId + '-symbol',
    //   'type': 'circle',
    //   'source': sourceId,
    //   'source-layer': 'symbol',
    //   'paint': {
    //     'circle-opacity': 0.6,
    //     'circle-color': 'red',
    //     'circle-stroke-width': 1,
    //     'circle-stroke-color': 'orange'
    //   }
    // })
  }

  return (
    <></>
  )
}
